import { Link } from 'react-router-dom';
import styles from './index.module.css';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import ScheduleIcon from '@mui/icons-material/Schedule';
import VideocamIcon from '@mui/icons-material/Videocam';
import LocationOnIcon from '@mui/icons-material/LocationOn';

interface Livestream {
  id: string;
  arenaName: string;
  courtName: string;
  city: string;
  state: string;
  thumbnailUrl?: string;
  scheduledAt?: string;
  cameras: number;
  viewerCount?: number;
}

interface LivestreamCardProps {
  livestream: Livestream;
  isLive: boolean;
}

function LivestreamCard({ livestream, isLive }: LivestreamCardProps) {
  const formatScheduledDate = (dateString?: string) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('pt-BR', {
      weekday: 'short',
      day: '2-digit',
      month: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  return (
    <Link to={`/livestream/${livestream.id}`} className={styles.card}>
      <div className={styles.thumbnail_wrapper}>
        {livestream.thumbnailUrl ? (
          <img
            src={livestream.thumbnailUrl}
            alt={`${livestream.arenaName} - ${livestream.courtName}`}
            className={styles.thumbnail}
          />
        ) : (
          <div className={styles.thumbnail_placeholder}>
            <VideocamIcon className={styles.placeholder_icon} />
          </div>
        )}

        {isLive && (
          <div className={styles.live_badge}>
            <span className={styles.live_dot}></span>
            AO VIVO
          </div>
        )}

        {!isLive && livestream.scheduledAt && (
          <div className={styles.scheduled_badge}>
            <ScheduleIcon className={styles.schedule_icon} />
            {formatScheduledDate(livestream.scheduledAt)}
          </div>
        )}

        <div className={styles.play_overlay}>
          <PlayArrowIcon className={styles.play_icon} />
        </div>
      </div>

      <div className={styles.info}>
        <h3 className={styles.arena_name}>{livestream.arenaName}</h3>
        <p className={styles.court_name}>{livestream.courtName}</p>

        <div className={styles.meta}>
          <div className={styles.meta_item}>
            <LocationOnIcon className={styles.meta_icon} />
            <span>{livestream.city}, {livestream.state}</span>
          </div>
          <div className={styles.meta_item}>
            <VideocamIcon className={styles.meta_icon} />
            <span>{livestream.cameras} câmera{livestream.cameras > 1 ? 's' : ''}</span>
          </div>
        </div>

        {isLive && livestream.viewerCount !== undefined && (
          <p className={styles.viewers}>
            {livestream.viewerCount} assistindo agora
          </p>
        )}
      </div>
    </Link>
  );
}

export default LivestreamCard;
